import React, { useEffect, useState } from 'react'
import { TitleBar } from '../../../Components/Common/TitleBar/titleBar';
import { Container, Card, CardBody, InputGroup } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getVehicleById } from "../../../slices/thunks";
import ResponsiveTabs from "../../../Components/Common/ResponsiveTabs";
import VehicleInsuranceTable from './Maintenance&InsuranceTable/VehicleInsuranceTable';
import VehicleMaintenanceTable from './Maintenance&InsuranceTable/VehicleMaintenanceTable';
import "../style.scss";

const tabs = [
    { id: "1", label: "Maintenance" }, { id: "2", label: "Insurance" },
];


function VehicleDetail() {
    const { id } = useParams();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState("1");

    const vehicleById = useSelector((state) => state.Vehicle.vehicleById);

    useEffect(() => {
        try {
            dispatch(getVehicleById(id));
        } catch (error) { }
    }, [id]);

    const vehicleDetailCards = [
        {
          title: "Vehicle Name",
          detail: vehicleById?.name || "-"
        },
        {
          title: "Vehicle Type",
          detail: vehicleById?.vehicle_type?.name || "-"
        },
        {
          title: "Model",
          detail: vehicleById?.model || "-"
        },
        {
          title: "Company Ownership",
          detail: vehicleById?.company_ownership || "-"
        },
        {
          title: "Year",
          detail: vehicleById?.year || "-"
        },
        {
          title: "Alias",
          detail: vehicleById?.alias || "-"
        },
      ];
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="d-flex flex-column gap-4">
                        <TitleBar title={`Vehicle Number : ${vehicleById?.number_plate}`} showIcon={true} />
                        <div className="dashbaord-card-container">
                            {vehicleDetailCards.map((element, index) => {
                                return (
                                    <Card key={index} className="card-animate dashboardCard mb-0">
                                        <CardBody>
                                            <div className="d-flex flex-column flex-sm-row justify-content-between">
                                                <div>
                                                    <p className="mb-0 vehicleTitle">
                                                        {element.title}
                                                    </p>
                                                    <h2 className="mt-3 ff-secondary fw-semibold vehicleValueCards">
                                                        <span >
                                                            {element.detail}
                                                        </span>
                                                    </h2>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                );
                            })}
                        </div>



                        <div className="maintaince-table-header d-flex flex-column-reverse flex-lg-row justify-content-start align-items-end p-2 p-lg-0 gap-1 gap-lg-0">
                            <ResponsiveTabs
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                                tabs={tabs}
                                isResponsive={false}
                            />
                        </div>
                        {activeTab === "1" ? <VehicleMaintenanceTable MaintenanceTableData={vehicleById?.maintenances} /> : <VehicleInsuranceTable InsuranceTableData={vehicleById?.insurances} />}
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default VehicleDetail
